import { isEmpty } from 'lodash-es'

const CONFERENCING_LOCATION_TYPES = [
  'gotomeeting',
  'gotomeeting_conference',
  'zoom',
  'zoom_conference',
  'google_conferencing',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference'
]

export function isConferencingLocation(locationTypeOrKind) {
  return CONFERENCING_LOCATION_TYPES.includes(locationTypeOrKind)
}

export function isMultipleLocation(locationConfigurations) {
  return locationConfigurations.length > 1
}

export function isWithoutLocation(ignoreLocationConfigurations, locationConfigurations) {
  return ignoreLocationConfigurations || isEmpty(locationConfigurations)
}
